import Http from "../util/Http";

class PostApi {
    
    static async getTotalBoardPosts(size = 3) {
        const res = await Http.get(`/posts/totalBoard?size=${size}`);
        return res || null;
    }

    static async getTotalBoardSecPosts(size = 3, postTypes = []) {
        const res = await Http.get(`/posts/totalBoard?size=${size}&isSec=true&postTypes=${postTypes.join(',')}`);
        return res || null;
    }

    static async getAllPosts(page, total = false, isMine = false) {
        const queryParams = new URLSearchParams({
            page,
            cnt: 30,  
            total,
            isMine,
            isAll: true
        }).toString();

        const res = await Http.get(`/posts?${queryParams}`);
        return res || null;
    }

    static async getPinnedPosts(searchKeyword = '') {
        const queryParams = new URLSearchParams({
            category : '', 
            page: 1, 
            cnt: 100, 
            isPinned: true, 
            searchKeyword,
            total: false
        }).toString();

        const res = await Http.get(`/posts?${queryParams}`);
        return res || null;
    }

    static async getPosts(type = 'PT001', page = 0, cnt = 20, isPinned = false, expireDate = '', searchKeyword = '', postLabel = '') {
        const queryParams = new URLSearchParams({
            type, 
            page, 
            cnt, 
            isPinned: isPinned.toString(), 
            expireDate, 
            searchKeyword,
            total: false,
            postLabel
        }).toString();

        const res = await Http.get(`/posts?${queryParams}`);
        return res || null;
    }

    static async getPostTotalCount(searchKeyword = '', type = 'PT001', postLabel = '') {
        const queryParams = new URLSearchParams({
            isPinned: false, 
            searchKeyword,
            total: true,
            type,
            postLabel
        }).toString();
        const res = await Http.get(`/posts?${queryParams}`);
        return res || 0;
    }

    static async getPostFull(postId, isMine = '') {
        const res = await Http.get(`/posts/${postId}?isFull=true&isMine=${isMine}`);
        return res || {};
    }

    static async createPost(postData) {
        const res = await Http.post('/posts', postData);
        return res || null;
    }

    static async updatePost(postId, postData) {
        const res = await Http.put(`/posts/${postId}`, postData);
        return res || null;
    }

    static async deletePost(postId) {
        const res = await Http.delete(`/posts/${postId}`);
        return res || null;
    }

    static async deleteMultiplePosts(postIds) {
        const res = await Http.post('/posts/delete-multiple', { post_ids: postIds });
        return res || null;
    }

    static async updateVisitCount(postId) {
        const res = await Http.post(`/posts/${postId}/visit`);
        return res || null;
    }

    static async getAnnoucePosts(postType) {
        const res = await Http.get(`/posts/announce?postType=${postType}`);
        return res || null;
    }

    static async updatePostReaction(postId, type) {
        const res = await Http.post(`/posts/reaction/${postId}/${type}`);
        return res || null;
    }

    static async getRecentContents() {
        const res = await Http.get('/posts/recentContents');
        return res || null;
    }

    static async getHomeMarketingPosts(limit = 10) {
        const res = await Http.get(`/posts/home/marketing?limit=${limit}`);
        return res || null;
    }

}

export default PostApi;
